import React, { createContext, useContext } from 'react';
import dateFnslocale from 'date-fns/locale/en-US';

import { BrandProvider } from './BrandProvider';
import { CurrencyFormatProvider } from './CurrencyFormatProvider';
import { CurrencyLocaleProvider } from './CurrencyLocaleProvider';
import { ThemeProvider } from './ThemeProvider';
import { VersionProvider } from './VersionProvider';

const DateFnsContext = createContext(dateFnslocale);

export const useDateFns = () => useContext(DateFnsContext);

const PrismaProvider = ({
  brand = 'ED',
  version,
  currencyLocale = { locale: 'en' },
  currencyFormat,
  dateFnsLocale,
  children,
}) => {
  return (
    <BrandProvider brand={brand}>
      <VersionProvider version={version}>
        <CurrencyLocaleProvider value={currencyLocale}>
          <CurrencyFormatProvider value={currencyFormat}>
            <DateFnsContext.Provider value={dateFnsLocale}>
              <ThemeProvider>{children}</ThemeProvider>
            </DateFnsContext.Provider>
          </CurrencyFormatProvider>
        </CurrencyLocaleProvider>
      </VersionProvider>
    </BrandProvider>
  );
};

export default PrismaProvider;
